// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const LockOpenIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.855 2.002a8.007 8.007 0 00-6.45 3.47c-.769 1.102.895 2.245 1.648 1.133a5.991 5.991 0 016.742-2.33C16.315 5.065 18.017 7.36 18 10h2c.022-3.51-2.256-6.582-5.605-7.633a7.977 7.977 0 00-2.54-.365zm1.129 14.739c1.784-1.009 1.076-3.727-.972-3.74-2.048-.014-2.79 2.695-1.02 3.727L10 19h3.978zM6 10h14v10a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2z" color="currentColor"/></svg>'} />;

LockOpenIcon.displayName = 'LockOpenIcon';

export default LockOpenIcon;
